import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: {
    displayName: "",
    initialPassword: null,
    email: "",
    phone: "",
    address: "",
    profilePictureUrl: "",
    accountType: "",
    adminId: "",
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.currentUser = payload;
    },
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
